import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { getRoutes } from "Router/getRoutes";
import { login } from "Thunks";
import {
  selectUser,
  selectNavCommunity,
  selectRouting,
  selectLoggedAs
} from "Selectors";

import { getAuthInfosFromCookie /*, redirectToHome*/ } from "Utils";

import ScrollToTop from "Common/ScrollToTop";
import Layout from "Layout/Layout";
import SelectCommunity from "SelectCommunity/SelectCommunity";
//import Home from "Home/Home";

import { TTP_PORTAL_URL } from "Config";

export class App extends Component {
  state = {
    loaded: false
  };

  static propTypes = {
    navCommunity: PropTypes.object,
    user: PropTypes.object,
    login: PropTypes.func.isRequired
  };

  componentDidMount(prevProps) {
    //this.props.login();
    //const auth = getAuthInfosFromCookie();
    if (
      window.location.origin === TTP_PORTAL_URL &&
      window.location.pathname.indexOf("/public/") === -1
    ) {
      this.props.login();
    } //else if (auth && auth.id) {
    //window.location.assign(TTP_PORTAL_URL);
    //}
    if (this.props.user === null) {
      $("#app-loader")
        .fadeOut()
        .promise()
        .done(() => $("#app-loader").remove());
    }
  }
  /*componentDidUpdate(prevProps, prevState) {
    if (!prevProps.user && this.props.user) {
      this.setState({ loaded: true });
    }

    if (!prevState.loaded && this.state.loaded) {
      $("#app-loader")
        .fadeOut()
        .promise()
        .done(() => $("#app-loader").remove());
    }
  }*/

  render() {
    const { navCommunity, routing } = this.props;

    if (
      window.location.origin === TTP_PORTAL_URL &&
      window.location.pathname.indexOf("/public/") === -1 &&
      !navCommunity
    ) {
      return <SelectCommunity />;
    }

    return (
      <ScrollToTop location={routing.location}>
        <Layout>{getRoutes()}</Layout>
      </ScrollToTop>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  navCommunity: selectNavCommunity(state),
  user: selectUser(state),
  loggedAs: selectLoggedAs(state),
  routing: selectRouting(state)
});

const mapDispatchToProps = dispatch => ({
  login: () => dispatch(login())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/components/App.js